const STATUS_ORDER = Object.freeze({
  active: 0,
  closed: 1,
});

export function getCreatedAtTimestamp(value) {
  if (!value) return 0;
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'string' || typeof value === 'number') return new Date(value).getTime() || 0;
  return 0;
}

export function getRecruitmentStatusOrder(status) {
  if (status in STATUS_ORDER) return STATUS_ORDER[status];
  return Number.MAX_SAFE_INTEGER;
}

export function sortRecruitmentsByStatusThenCreatedAtDesc(items) {
  return [...items].sort((a, b) => {
    const statusDelta = getRecruitmentStatusOrder(a.status) - getRecruitmentStatusOrder(b.status);
    if (statusDelta !== 0) return statusDelta;
    return getCreatedAtTimestamp(b.createdAt) - getCreatedAtTimestamp(a.createdAt);
  });
}
